import numeral from "numeral";

export const Currency = ({ value }) => {
  const formattedNumber = numeral(value).format("0,0");
  return `${formattedNumber}₮`;
};
